var _defs, _rect, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTriage(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "\\u56FE\\u5C42_1",
    "data-name": "\\u56FE\\u5C42 1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 64 64",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:url(#\u672A\u547D\u540D\u7684\u6E10\u53D8_16);}.cls-2{fill:#fff;}"), /*#__PURE__*/React.createElement("linearGradient", {
    id: "\\u672A\\u547D\\u540D\\u7684\\u6E10\\u53D8_16",
    x1: 32.01,
    y1: 62.59,
    x2: 31.99,
    y2: -1.43,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.03,
    stopColor: "#3cc9a6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#58e39f"
  })))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "z4_\u9884\u68C0\u5206\u8BCA") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    width: 64,
    height: 64,
    rx: 4
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M29,15.83H17a1,1,0,0,0-1,1h0v4a1,1,0,0,0,1,1H29a1,1,0,0,0,1-1h0v-4a1,1,0,0,0-1-1ZM50.82,30A4,4,0,0,0,48,28.82V20.33a1.5,1.5,0,1,0-3-.16.43.43,0,0,0,0,.16v8.49H42v-4.5a1.5,1.5,0,0,0-3,0v4.5H25v-3h7a2,2,0,0,0,2-2h0v-10a2,2,0,0,0-2-2H14a2,2,0,0,0-2,2h0v10a2,2,0,0,0,2,2h8v3H16a4,4,0,0,0-4,4v17a2,2,0,0,0,2,2h3a2,2,0,0,0,2-2h0v-12a2,2,0,0,1,2-2H36a2,2,0,0,1,2,2h0v12a2,2,0,0,0,2,2H50a2,2,0,0,0,2-2h0v-17A4,4,0,0,0,50.82,30ZM15,23.82a1,1,0,0,1-1-1h0v-8a1,1,0,0,1,1-1H31a1,1,0,0,1,1,1h0v8a1,1,0,0,1-1,1H15Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTriage);
export default __webpack_public_path__ + "static/media/Triage.900ba7cd.svg";
export { ForwardRef as ReactComponent };